import awards from "../sites/awards_2021";

import { setSlimRequireContext } from "../shared/scripts/utils/react_rails";

setSlimRequireContext(require.context("components", true));

awards();
